import { Image } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import ClipboardMarkWithBackground from "@src/appV2/lib/assets/illustrations/clipboard-mark-with-background.svg";
import { isRebrandingEnabled } from "@src/appV2/redesign/Rebranding/workerAppRebranding";

import clipboardLogoWithoutWatermark from "../assets/images/cbh-logo-without-wordmark.png";

interface ClipboardLogoProps {
  width?: number;
}

export function ClipboardLogo(props: ClipboardLogoProps = {}) {
  const { width = 120 } = props;

  if (isRebrandingEnabled()) {
    return (
      <Box sx={{ width }}>
        <ClipboardMarkWithBackground />
      </Box>
    );
  }

  return <Image src={clipboardLogoWithoutWatermark} alt="Clipboard" width={width} />;
}
